import React, { useState, useEffect } from 'react';

// Counter component to animate counting up
const Counter = ({ target, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount < target) {
          return prevCount + 100; 
        } else {
          clearInterval(interval);
          return target;
        }
      });
    }, 10); 

    return () => clearInterval(interval);
  }, [target]);

  return (
    <li>
      <h2>{count}+</h2>
      <p>{label}</p>
    </li>
  );
};

const Statistics = () => {
  return (
    <section className="static-section yellow-background">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <h2>
              <span className='text-white'>Why Choose Anjali Enterprises?</span>
            </h2>
            <p className="fnt-18 text-white">
              Trusted by thousands for premium-quality services in fabrication, installation, and renovation.  
              <br />
              Delivering excellence in both industrial and residential projects.
            </p>
          </div>

          {/* Counter statistics list */}
          <ul>
            <Counter target={5000} label="Projects Completed" />
            <Counter target={3500} label="Happy Customers" />
            <Counter target={15000} label="Hours of Work" />
            <Counter target={1000} label="Fabrication Solutions" />
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Statistics;
